<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs" :class="headerStyle">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/images/header/logo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n" @click="navTo(n, i.path)">
              {{ i.name }}
            </dt>
          </dl>
        </li>

        <li>
          <img v-if="headerStyle == 'light'" class="phone-img" src="../assets/images/footer/phone.png" alt="">
          <img v-if="headerStyle == 'dark'" class="phone-img" src="../assets/images/header/phone-dark.png" alt="">
          <span class="phone-num">400-096-7686</span>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">

      <!-- 导航栏 -->
      <div class="header-nav-m-menu">
        <img class="header-nav-logo" src="@/assets/images/header/logo.png" alt="logo">
        <!-- {{ menuName }} -->
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''">
            <router-link :to="item.path" @click="navClick(index, item.name)">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length > 0" :class="{ 'show': mobileExpandedIndex === index }">
              <dt v-for="(i, n) in item.children" :key="n" @click="navTo(index, i.path)">
                {{ i.name }}
              </dt>
            </dl>
            <span v-if="item.children.length > 0" class="mobile-toggle" @click="toggleMobileSubMenu(index)">
              <i :class="mobileExpandedIndex === index ? 'glyphicon glyphicon-menu-up' : 'glyphicon glyphicon-menu-down'"></i>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      headerStyle: 'light',
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "产品中心",
          path: "/products",
          children: [
            {
              name: "SFA",
              path: "/products/sfa"
            },
            {
              name: "SPS",
              path: "/products/sps"
            },
            {
              name: "TPM",
              path: "/products/tpm"
            },
            {
              name: "DMS",
              path: "/products/dms"
            },
            {
              name: "b-CRM",
              path: "/products/crm"
            },
            {
              name: "一物一码",
              path: "/products/ywym"
            },
            {
              name: "AI应用",
              path: "/products/ai"
            },
          ]
        },
        {
          name: "客户案例",
          path: "/customer",
          children: [
            {
              name: "青岛啤酒",
              path: "/customer/qdpj"
            },
            {
              name: "蒙牛乳业",
              path: "/customer/mnry"
            },
            {
              name: "汾酒集团",
              path: "/customer/fjjt"
            }
          ]
        },
        {
          name: "公司简介",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ],
      mobileExpandedIndex: -1 // 用于记录移动端展开的一级菜单索引
    };
  },
  mounted() {
    console.log(sessionStorage.getItem('navIndex'))
    this.setHeaderStyle();
  },
  watch: {
    $route: {
      immediate: true,
      deep: true, // 深度监听
      handler(to, from) {
        this.$nextTick(() => {
          this.mobileExpandedIndex = -1;
          this.menuClass = "glyphicon glyphicon-menu-down";
          console.log(document.getElementById('menu').classList)
          document.getElementById('menu').classList.remove('in');
          if (this.navList && this.navList.length > 0) {
            // 组件加载后执行
            if (to.path == '/' || to.path == '/home') {
              this.navIndex = 0;
            } else {
              // 获取当前路由的索引
              this.navIndex = this.navList.findIndex(item => to.path.includes(item.path) && item.path != '/');
            }
            sessionStorage.setItem('navIndex', this.navIndex)
            this.setHeaderStyle();
            window.scrollTo(0, 0);
          }
        });
      }
    }
  },

  methods: {
    navTo(index, path) {
      console.log(index)
      console.log(path)
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.$router.push(path);
      this.setHeaderStyle();
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
      this.setHeaderStyle();
    },
    setHeaderStyle() {
      if (sessionStorage.getItem('navIndex') == 1 || sessionStorage.getItem('navIndex') == 2 || sessionStorage.getItem('navIndex') == 3) {
        this.headerStyle = "dark";
      } else {
        this.headerStyle = "light";
      }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    toggleMobileSubMenu(index) {
      if (this.mobileExpandedIndex === index) {
        this.mobileExpandedIndex = -1; // 关闭菜单
      } else {
        this.mobileExpandedIndex = index; // 展开菜单
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  /* background: #f4f4f4; */
  /* transition: all ease 0.6s;
  position: top;
  top: 0;
  width: 100%;
  z-index: 1000; */
}

#header.drak .header-top {
  color: #000;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 80px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  /* width: 95px; */
  height: 25x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #fff;
  font-size: 16px;
  font-weight: Medium;
  padding: 12px 0;
  position: relative;
}

#header .header-nav.dark .header-nav-wrapper>li>a {
  color: #000;
}

#header .phone-img {
  position: relative;
  top: -2px;
  display: inline;
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

#header .header-nav .phone-num {
  position: relative;
  top: -2px;
  vertical-align: middle;
  color: #fff;
  font-size: 22px;
  font-weight: bold;
  padding: 12px 0;
  position: relative;
}

#header .header-nav.dark .phone-num {
  color: #000;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #39FEFF;
}

#header .header-nav.dark .header-nav-wrapper>li>a>i {
  background-color: rgba(0, 110, 237, 1);
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #39FEFF;
  text-decoration: none;
}

#header .header-nav.dark .header-nav-wrapper>li>a:hover {
  color: rgba(0, 110, 237, 1);
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #39FEFF;
  text-decoration: none;
  border-bottom: 2px solid #39FEFF;
}

#header .header-nav.dark .header-nav-wrapper>li.active>a {
  color: rgba(0, 110, 237, 1);
  border-bottom: 2px solid rgba(0, 110, 237, 1);
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 85%;
  left: 0;
  z-index: 999999;
  /* box-shadow: 0 0 3px 1px rgba(57, 254, 255, 1); */
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: #fff;
  padding-bottom: 15px;
  padding-left: 15px;
}

#header .header-nav.dark .header-nav-wrapper>li>dl {
  /* box-shadow: 0 0 3px 1px rgba(0, 110, 237, 1); */
  padding-bottom: 15px;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding-top: 15px;
  /* border-bottom: 1px solid rgba(57, 254, 255, 1); */
}

#header .header-nav.dark .header-nav-wrapper>li>dl>dt {
  /* border-bottom: 1px solid rgba(0, 110, 237, 1); */
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  color: #39FEFF;
  /* background: rgba(57, 254, 255, 0.3); */
}

#header .header-nav.dark .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  color: rgba(0, 110, 237);
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
    background-color: #fff;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-logo {
    /* width: 95px; */
    height: 25px;
    display: inline-block;
    /* top: 0;
    left: 0;
    right: 0;
    bottom: 0; */
    margin: 0 20px;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #000;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    /* background: #474747; */
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 0px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    /* color: #fff; */
    z-index: 999999;
    font-size: 20px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: auto; /* 修改为auto以适应展开的子菜单 */
    line-height: 40px;
    border-bottom: 1px solid #ccc;
    position: relative;
    padding-left: 15px;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    /* font-weight: bold; */
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的二级导航容器 */
  #header .header-nav-m .header-nav-m-wrapper>li>dl {
    display: none;
    /* background: #333; */
    /* padding: 10px; */
  }

  #header .header-nav-m .header-nav-m-wrapper>li>dl.show {
    display: block;
  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li>dl>dt {
    padding: 10px;
    font-weight: 400;
    font-size: 15px;
    color: #fff;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }

  /* 移动端展开/收起按钮 */
  .mobile-toggle {
    position: absolute;
    right: 29px;
    top: 0%;
    /* transform: translateY(-50%); */
    color: #fff;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue